// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"2c9935c0","897":"25eb2203"}[chunkId] + ".chunk.js";
};